
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/home",
      function () {
        return require("private-next-pages/de/home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de/home"])
      });
    }
  